export const breakpoints = {
  mobile: "37.5em",
  xs: "37.5em",
  sm: "50em",
  md: "64em",
  lg: "70em",
}
